import { useState } from "react";

const navItems = [
  { label: "热词索引", href: "#hot" },
  { label: "专题精选", href: "#topics" },
  { label: "内容查询", href: "#query" },
  { label: "更新动态", href: "#feed" },
  { label: "使用指引", href: "#guide" },
];

export default function TopBar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      {/* 运营顶条 */}
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto flex h-8 max-w-7xl flex-col sm:flex-row items-center justify-between px-4 md:px-6">
          <p className="text-[11px] tracking-wide opacity-80">
            网黑料内容检索门户 · 聚合专题更新于今日
          </p>
          <div className="hidden sm:flex items-center gap-4 text-[11px] opacity-80">
            <span className="inline-flex items-center gap-1 whitespace-nowrap">
              <i className="ri-checkbox-circle-line text-accent-300"></i>专题持续归档
            </span>
            <a href="#guide" className="hover:text-accent-300 transition-colors whitespace-nowrap">检索说明</a>
          </div>
        </div>
      </div>

      {/* 主搜索条 */}
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3 md:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center justify-between gap-4">
          <a href="#" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-archive-drawer-line text-lg"></i>
            </span>
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
              网黑料
            </span>
            <span className="hidden rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900 xl:inline-flex whitespace-nowrap">
              聚合门户
            </span>
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-900 lg:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-2-line text-lg"}></i>
          </button>
        </div>

        <form
          onSubmit={(e) => e.preventDefault()}
          className="flex flex-1 items-center gap-0 rounded-full border border-background-300 bg-background-50 p-1 lg:mx-6 lg:max-w-2xl"
        >
          <i className="ri-search-2-line ml-3 text-base text-foreground-400"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            aria-label="站内搜索"
            placeholder="输入关键词，快速查找专题与内容…"
            className="w-full bg-transparent px-2 py-1.5 text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
          />
          <button
            type="button"
            onClick={() => setKeyword("")}
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            查找
          </button>
        </form>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950 whitespace-nowrap"
            >
              {n.label}
            </a>
          ))}
        </nav>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-wrap gap-2">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-800 whitespace-nowrap"
              >
                {n.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}